var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesCardAdditionalInfoUnlit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 16,
    r: 16,
    fill: "#F05A22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10C17.1989 10 17.3897 10.079 17.5303 10.2197C17.671 10.3603 17.75 10.5511 17.75 10.75V15H22C22.1989 15 22.3897 15.079 22.5303 15.2197C22.671 15.3603 22.75 15.5511 22.75 15.75C22.75 15.9489 22.671 16.1397 22.5303 16.2803C22.3897 16.421 22.1989 16.5 22 16.5H17.75V20.75C17.75 20.9489 17.671 21.1397 17.5303 21.2803C17.3897 21.421 17.1989 21.5 17 21.5C16.8011 21.5 16.6103 21.421 16.4697 21.2803C16.329 21.1397 16.25 20.9489 16.25 20.75V16.5H12C11.8011 16.5 11.6103 16.421 11.4697 16.2803C11.329 16.1397 11.25 15.9489 11.25 15.75C11.25 15.5511 11.329 15.3603 11.4697 15.2197C11.6103 15.079 11.8011 15 12 15H16.25V10.75C16.25 10.5511 16.329 10.3603 16.4697 10.2197C16.6103 10.079 16.8011 10 17 10Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesCardAdditionalInfoUnlit);
export default __webpack_public_path__ + "static/media/servicesCardAdditionalInfoUnlit.4741391bebf4ef2542c2159fbbc99717.svg";
export { ForwardRef as ReactComponent };